module.exports = __webpack_public_path__ + "static/media/getAppGallery.8f7d1496.svg";